import AgoraRTC, { usePublish } from "agora-rtc-react";
import React from "react";

export const useAgoraPublish = (args: {
  audioTrack: MediaStreamTrack | undefined;
  videoTrack: MediaStreamTrack | undefined;
  isAudioEnabled: boolean;
  isVideoEnabled: boolean;
}) => {
  const { audioTrack, videoTrack, isAudioEnabled, isVideoEnabled } = args;

  const agoraAudioTrack = React.useMemo(() => {
    if (!audioTrack) return null;
    return AgoraRTC.createCustomAudioTrack({
      mediaStreamTrack: audioTrack,
    });
  }, [audioTrack]);

  const agoraVideoTrack = React.useMemo(() => {
    if (!videoTrack) return null;
    return AgoraRTC.createCustomVideoTrack({
      mediaStreamTrack: videoTrack,
    });
  }, [videoTrack]);

  React.useEffect(() => {
    if (agoraVideoTrack) {
      agoraVideoTrack.setMuted(!isVideoEnabled);
    }
  }, [agoraVideoTrack, isVideoEnabled, videoTrack]);

  React.useEffect(() => {
    if (agoraAudioTrack) {
      agoraAudioTrack.setMuted(!isAudioEnabled);
    }
  }, [isAudioEnabled, audioTrack, agoraAudioTrack]);

  usePublish([agoraAudioTrack, agoraVideoTrack]);

  return;
};
